// extracted by mini-css-extract-plugin
export default {"container":"tagInput_container__bZNBY","errorContainer":"tagInput_errorContainer__5rV2q"};